package com.appcreator.compose.conversions

import com.appcreator.blueprint.conversions.SubstringConversion
import com.appcreator.blueprint.core.EnvStore
import kotlinx.serialization.json.JsonElement

class SubstringConvertor(
    val conversion: SubstringConversion
): Convertor {

    override fun convert(envStore: EnvStore, jsonElement: JsonElement?): String? {
        with(conversion) {
            val raw = envStore.injectVariables(conversion.value ?: "")
            return raw.substring(conversion.start ?: 0, conversion.end ?: 0)
        }
    }
}
